import { HostRunStatus, HostRunStatusCount } from '@goto/remote-execution';

export function mapHostRunStatusCountToJobStatus(deviceJobStatuses: HostRunStatusCount[]): HostRunStatus {
  if (deviceJobStatuses.some(s => s.status == HostRunStatus.Pending && s.count > 0)) return HostRunStatus.Pending;
  if (deviceJobStatuses.some(s => s.status == HostRunStatus.Running && s.count > 0)) return HostRunStatus.Running;
  if (deviceJobStatuses.some(s => s.status == HostRunStatus.Failed && s.count > 0)) return HostRunStatus.Failed;
  if (deviceJobStatuses.some(s => s.status == HostRunStatus.Cancelled && s.count > 0)) return HostRunStatus.Cancelled;
  return HostRunStatus.Finished;
}
